import { useIntl } from 'react-intl';

import { type ChargingStop, EV_DEMO_PROFILE } from './smartRoute.ts';

export const EvChargingPreview = ({ stops }: { stops: ChargingStop[] }) => {
    const intl = useIntl();
    return (
        <div className='margin-top-10'>
            <div className='text-size-12'>
                {intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.smart-route.ev-disclaimer' })}
            </div>
            <div className='margin-top-5'>
                {intl.formatMessage(
                    { id: 'intl-msg:ordercom-cloud-frontend.smart-route.ev-summary' },
                    {
                        count: stops.length,
                        minutes: Math.ceil(stops.reduce((sum, stop) => sum + stop.duration, 0) / 60),
                    }
                )}
            </div>
            {stops.length > 0 && (
                <ol className='margin-top-5 margin-bottom-0 padding-left-20 overflow-auto' style={{ maxHeight: 160 }}>
                    {stops.map((stop, index) => (
                        <li key={stop.id}>
                            {stop.name && <strong>{stop.name}: </strong>}
                            {intl.formatMessage(
                                { id: 'intl-msg:ordercom-cloud-frontend.smart-route.ev-stop' },
                                {
                                    number: index + 1,
                                    minutes: Math.ceil(stop.duration / 60),
                                    arrival: Math.round((stop.arrivalCharge / EV_DEMO_PROFILE.maxCharge) * 100),
                                    departure: Math.round((stop.targetCharge / EV_DEMO_PROFILE.maxCharge) * 100),
                                }
                            )}
                        </li>
                    ))}
                </ol>
            )}
        </div>
    );
};
